import type { MutableRefObject } from 'react';
import { useEffect, useRef, useState } from 'react';
import { useSettings } from '@wu/widget-core';
import { useChat } from '../../chat';

export const useTyping = () => {
  const { position, renderThumbnailMode } = useSettings();
  const { openChatWindow, messageShowed, setMessageShowed } = useChat();
  const [typing, setTyping] = useState(true);

  const timeoutRef: MutableRefObject<NodeJS.Timeout | null> = useRef(null);

  useEffect(() => {
    setMessageShowed(false);
  }, [position, setMessageShowed]);

  useEffect(() => {
    if (renderThumbnailMode) {
      setMessageShowed(true);
      setTyping(false);

      return;
    }

    if (openChatWindow && !messageShowed && typing) {
      timeoutRef.current = setTimeout(() => {
        setTyping(false);
        setMessageShowed(true);
      }, 3000);
    }

    if (position === 'embed-chat' && typing) {
      setTyping(false);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [
    openChatWindow,
    messageShowed,
    typing,
    position,
    renderThumbnailMode,
    setMessageShowed
  ]);

  return typing;
};
